module.exports = __webpack_public_path__ + "img/ke.f50e23ed.svg";